export default {"src":"/_next/static/media/0x8888801aF4d980682e47f1A9036e589479e835C5.2d5e5205.svg","height":292,"width":419,"blurWidth":0,"blurHeight":0};